// extracted by mini-css-extract-plugin
export default {"zoomModal":"l2-z","image":"m2-z","button":"n2-z","isOverlayShown":"o2-z"};